window.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.hubspot-newsletter-form form');
  const emailInput = document.querySelector('.newsletter-email-field input[name="email"]');
  const submitButton = document.querySelector('.hubspot-newsletter-form .submit-button');
  const successFormContent = document.querySelector('.hubspot-newsletter-form .newsletter-form__message--success')
  const errorMessage = document.querySelector('.hubspot-newsletter-form .newsletter-form__message--error');
  const originalButtonHTML = submitButton.innerHTML;
  submitButton.disabled = true;
  function validateForm() {
    const isEmailFilled = emailInput.value.trim() !== '';
    submitButton.disabled = !isEmailFilled;
  }
  validateForm();
  emailInput.addEventListener('input', validateForm);

  function resetForm() {
    submitButton.innerHTML = originalButtonHTML;
    submitButton.disabled = false;
    emailInput.value = '';
  }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    await insiderTracking.trackEvent('ecom_allgood_form_submit', {
      "c_list_name": "home_newsletter_form_footer"
    });
    submitButton.innerHTML = "<span style='width: 20px; height:20px;' class='loader'></span>";
    submitButton.disabled = true;

    const formData = {
      email: emailInput.value.trim(),
    };

    try {
      const response = await fetch(
        'https://api.hsforms.com/submissions/v3/integration/submit/40224670/378755a9-014e-40e9-a54f-367441b77b07',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            fields: [
              { name: 'email', value: formData.email },
              { name: 'contact__general__business_unit', value: 'Grupo' },
            ],
            context: {
              pageUri: window.location.href,
              pageName: document.title,
            },
            legalConsentOptions: {
              consent: {
                consentToProcess: true,
                text: 'Eu concordo em permitir o processamento de meus dados.',
                communications: [
                  {
                    value: true,
                    subscriptionTypeId: 688400108,
                    text: 'Aceito receber comunicações sobre novidades e promoções.',
                  },
                ],
              },
            },
          }),
        }
      );

      if (response.ok) {
        successFormContent.classList.remove('hidden');
        localStorage.setItem('sentform', 'Yes');
      } else {
        errorMessage.classList.remove('hidden');
      }
    } catch (error) {
      errorMessage.classList.remove('hidden');
    }

    resetForm();
  });
})